import CampaignZoom from "../../Components/CampaignZoom";
import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { campaignKatabasis } from "../../Utils/CampaignDefinitions";

const Katabasis = () => {
  const [fullScreenPicture, setFullScreenPicture] = useState<
    string | undefined
  >(undefined);
  const picList = [
    "/katabasis/Katabasis1.jpg",
    "/katabasis/Katabasis2.jpg",
    "/katabasis/Katabasis3.jpg",
    "/katabasis/Katabasis4.jpg",
    "/katabasis/Katabasis5.jpg",
    "/katabasis/Katabasis6.jpg",
    "/katabasis/Katabasis7.jpg",
    "/katabasis/Katabasis8.jpg",
    "/katabasis/Katabasis9.jpg",
    "/katabasis/Katabasis10.jpg",
  ];

  const [scrollPosition, setScrollPosition] = useState<number>(0);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleScroll = () => {
    window.scrollTo(0, scrollPosition);
  };

  const renderVerticalRange = (range: string[]) => (
    <div className="campaignPicRange pointer">
      {range.map((picture, key) => (
        <img
          key={key}
          aria-label="Campaign Katabasis squillace 1923 leather gloves"
          className="campaignPicVerticalKatabasis"
          src={`/katabasis/${picture}`}
          alt={`campaign ${campaignKatabasis.title} squillace1923 gloves`}
          onClick={() => {
            setScrollPosition(window.pageYOffset);
            setFullScreenPicture(`/katabasis/${picture}`);
          }}
        />
      ))}
    </div>
  );

  const renderHorizontalRange = (range: string) => (
    <div className="campaignPicRange">
      <img
        key={3}
        aria-label="Campaign Katabasis squillace 1923 leather gloves"
        className="campaignPicHorizontal pointer"
        src={`/katabasis/${range}`}
        alt={`campaign ${campaignKatabasis.title} squillace1923 gloves`}
        onClick={() => {
          setScrollPosition(window.pageYOffset);
          setFullScreenPicture(`/katabasis/${range}`);
        }}
      />
    </div>
  );
  const ranges = campaignKatabasis.pictureRanges;

  return (
    <div className="content">
      <Helmet>
        <meta charSet="utf-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1"
        ></meta>
        <title>
          Squillace 1923 - Luxury leather gloves campaign handmade in Italy -
          Katabasis season 23
        </title>

        <meta
          name="description"
          content="Squillace 1923 is the Haute Couture brand by Omega srl. 
    Luxurious and elegant leather gloves collections, made in Naples following the ancestral phases of production, entirely handmade."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>
      <div className="title">
        <h1>{campaignKatabasis.title.toUpperCase()}</h1>
        <h2>
          {campaignKatabasis.description.map((text, index) => (
            <>
              {text}
              <br></br>
              <br></br>
            </>
          ))}
        </h2>
      </div>
      <div className="campaignPic">
        {renderVerticalRange(ranges.firstRange)}
        {renderVerticalRange(ranges.secondRange)}
        {renderHorizontalRange(ranges.thirdRange)}
        {renderVerticalRange(ranges.fourthRange)}
        {renderVerticalRange(ranges.fifthRange)}
        {renderHorizontalRange(ranges.sixthRange)}
      </div>

      {fullScreenPicture && (
        <CampaignZoom
          picList={picList}
          fullScreenPicture={fullScreenPicture}
          setFullScreenPicture={setFullScreenPicture}
          handleScroll={handleScroll}
        />
      )}
    </div>
  );
};

export default Katabasis;
